<template>
  <div>
    <yw-head></yw-head>
    <div class="web-body">
      <div class="chu_ti">
        <h2>我要出题</h2>
      </div>
      
      
      <div class="chu_ti_form_box">
        <form class="form-horizontal" @submit.prevent="submitFrom">
          <div class="form-group">
            <label for="inputEmail3" class="col-sm-2 control-label">我的昵称：</label>
            <div class="col-sm-6">
              <input type="text" class="form-control col-sm-6" id="inputEmail3" placeholder="我的昵称" required>
            </div>
          </div>
          <div class="form-group">
            <label for="song" class="col-sm-2 control-label">上传歌曲：</label>
            <input type="file" id="song" class="col-sm-6" accept=".mp3,.MP3,.wav,.WAV" required>
            <br/>
            <p class="col-sm-6 help-block">仅支持mp3、wav格式</p>
          </div>
          <div class="form-group">
            <label for="picture" class="col-sm-2 control-label">专辑图片：</label>
            <input type="file" id="picture" class="col-sm-6" accept=".png,.PNG,.jpeg,.jpg,.JPG,.JPEG" required>
            <br/>
            <p class="col-sm-6 help-block">仅支持png、jpg格式</p>
          </div>
          
          <div class="form-group">
            <label for="sel1" class="col-sm-2 control-label">选项一：</label>
            <div class="col-sm-4">
              <input type="text" class="form-control col-sm-6" id="sel1" placeholder="选项一" required>
            </div>
            <label class="col-sm-2 ">
              <input type="radio" name="inlineRadioOptions" id="rsel1" value="1" checked required> <span
              class="radio_text">正确答案</span>
            </label>
          </div>
          
          <div class="form-group">
            <label for="sel2" class="col-sm-2 control-label">选项二：</label>
            <div class="col-sm-4">
              <input type="text" class="form-control col-sm-6" id="sel2" placeholder="选项二" required>
            </div>
            <label class="col-sm-2">
              <input type="radio" name="inlineRadioOptions" id="rsel2" value="2" required> <span
              class="radio_text">正确答案</span>
            </label>
          </div>
          
          <div class="form-group">
            <label for="sel3" class="col-sm-2 control-label">选项三：</label>
            <div class="col-sm-4">
              <input type="text" class="form-control col-sm-6" id="sel3" placeholder="选项三" required>
            </div>
            <label class="col-sm-2">
              <input type="radio" name="inlineRadioOptions" id="rsel3" value="3" required> <span
              class="radio_text">正确答案</span>
            </label>
          </div>
          
          <div class="form-group">
            <label for="sel4" class="col-sm-2 control-label">选项四：</label>
            <div class="col-sm-4">
              <input type="text" class="form-control col-sm-6" id="sel4" placeholder="选项四" required>
            </div>
            <label class="col-sm-2">
              <input type="radio" name="inlineRadioOptions" id="rsel4" value="4" required> <span
              class="radio_text">正确答案</span>
            </label>
          </div>
          
          <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
              <div class="checkbox">
                <label>
                  <input type="checkbox" required>
                  <span>同意遵守用户行为规范，并已阅读<router-link to="/chu_ti_ban_quan" class="ban_quan">版权声明</router-link></span>
                </label>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
              <button type="submit" class="btn btn-default">上传提交</button>
            </div>
          </div>
        
        </form>
      </div>
      
      <div class="tips">
        
        <h3>出题规范</h3>
        <h5>1、目前能够创建的题目类型为选择题，需填写1个正确答案和3个错误答案，每个答案的长度在1~11字之间。</h5>
        <h5> 2、正确填写所有内容后即可提交审核，玩家每天可以提交5道题。审核通过后，才会展示在游戏中。</h5>
        <h5> 3、审核通常会在一段时间后完成，一经采用，提交者的昵称会显示在游戏中，也会收到游戏内的奖励。</h5>
        
        <h3> 免责声明</h3>
        <h5>
          由于《猜歌达人》APP内全部歌曲来自用户上传，对非法转载、盗版等侵权行为的发生不具备充分的监控能力。知识产权权利人发现在《猜歌达人》上的内容侵犯其知识产权权利时，可向《猜歌达人》发送邮件申请，要求删除侵权内容。《猜歌达人》将根据有关法律规定采取措施删除相关内容。
        </h5>
      </div>
      
      <div class="tips">
        <h3> 用户行为规范</h3>
        <h5> 1、用户在使用《猜歌达人》服务时不得从事以下行为：</h5>
        <h6>（1）发布、传送、传播、储存违反国家法律、危害国家安全统一、社会稳定、公序良俗、社会公德以及侮辱、诽谤、淫秽、暴力的内容；</h6>
        <h6> （2）发布、上传、传播、储存侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的内容；</h6>
        <h6> （3）使用任何包含有通过侵犯知识产权、商业机密或任何一方的其他合法权利的方式利用本服务获得的相应的音频、视频资料；</h6>
        <h6> （4）制作、发布、传播用于窃取他人帐号及他人专属信息、财产、保密信息的软件；</h6>
        <h6> （5）在未经《猜歌达人》书面明确授权前提下，出售、出租、出借、散布、转移或转授权本软件和本服务或相关的链接或从使用软件和服务或软件和服务的条款中获利，无论以上使用是否为直接经济或金钱收益；</h6>
        <h6> （6）未经《猜歌达人》允许，擅自将本“软件”、本服务的音乐内容资源库中的任何音乐资源应用于商业用途或进行营利活动；</h6>
        <h6> （7）虚构事实、隐瞒真相以误导、欺骗他人；</h6>
        <h6> （8）发表、传送、传播垃圾信息；</h6>
        <h6> （9）以其他以任何不合法的方式、为任何不合法的目的、或以任何与本协议不一致的方式使用本软件和本服务；</h6>
        <h6> （10）从事其他违反法律法规、政策及公序良俗、社会公德等的行为。</h6>
        <h5>
          2、用户在使用《猜歌达人》服务时，如应严格遵循上述约定，因用户不当使用《猜歌达人》服务而造成的其自己、《猜歌达人》或其他第三方的损失，均应由该用户承担。同时，用户应自行判断信息内容的真实性、合法性和有效性，并自行承担使用该等信息内容可能产生的一切后果与责任</h5>
      </div>
    
    </div>
    
    
    <yw-footer></yw-footer>
  
  </div>

</template>

<script>
  
  import yw_head from './yw_head';
  import yw_footer from './yw_footer';
  
  export default {
    name: "chu_ti",
    data() {
      return {
        formData: {
          name: "",
          opn: "",
          huolg: "",
          yezi: "",
          weidao: "",
        }
      };
    },
    components: {
      'yw-head': yw_head,
      'yw-footer': yw_footer
    },
    methods: {
      submitFrom() {
        console.log("submitFrom",this.formData);
        setTimeout(function () {
          alert("上传成功");
        }, Math.random() * 100 + 1000)
      }
    }
  }

</script>

<style scoped>
  .tips {
    color: #888;
  }
  
  .chu_ti_form_box {
    background: #eee;
    padding: 50px;
    margin: 50px auto;
    border-radius: 10px;
  }
  
  .radio_text {
    display: inline-block;
    margin-left: 4px;
    color: #666;
  }
  
  .ban_quan {
    color: #1179FF;
  }
</style>



// WEBPACK FOOTER //
// src/components/chu_ti.vue